import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from 'styled-components';
export var ToolbarContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: ", ";\n  flex-direction: ", ";\n  /* justify-content: center; */\n  justify-content: space-evenly;\n\n  ", ";\n"])), function (_ref) {
  var isYearOnly = _ref.isYearOnly;
  return isYearOnly ? 'center' : 'flex-start';
}, function (_ref2) {
  var isYearOnly = _ref2.isYearOnly;
  return isYearOnly ? 'row' : 'column';
}, function (_ref3) {
  var theme = _ref3.theme;
  return _extends({}, theme.calendar.toolbar);
});
export var ToolbarButton = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  cursor: pointer;\n\n  ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme,
    selected = _ref4.selected;
  return _extends({}, theme.calendar.toolbarButton, {
    color: selected ? theme.calendar.toolbarSelectedTextColor : theme.calendar.toolbarTextColor,
    fontSize: selected ? theme.calendar.toolbarSelectedFontSize : theme.calendar.toolbarButton.fontSize,
    fontFamily: selected ? theme.calendar.toolbarSelectedFontFamily : theme.calendar.toolbarButton.fontFamily
  });
});